module.exports = __webpack_public_path__ + "img/19181491.dc059337.png";